// Founder signature wipe-reveal (mirror: clip-path inset transition 1.3s
// ease-out .25s, IntersectionObserver threshold .35 on the TEXT PARENT).
// The signature is VISIBLE by default (no-JS safe); JS arms the hidden clip
// first, then the observer releases it so the wipe plays on scroll-in.
// Reduced motion: never armed - signature just shows.
class SkulletteSignatureReveal extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const sig = this.querySelector('[data-sig]');
    if (!sig || !('IntersectionObserver' in window)) return;
    sig.classList.add('sk-sig--armed');
    // force style flush so the un-arm below actually transitions
    void sig.offsetWidth;
    this._obs = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) {
        sig.classList.remove('sk-sig--armed');
        this._obs.disconnect();
      }
    }, { threshold: 0.35 });
    this._obs.observe(this);
  }

  disconnectedCallback() {
    this._obs?.disconnect();
  }
}

if (!customElements.get('skullette-signature-reveal')) {
  customElements.define('skullette-signature-reveal', SkulletteSignatureReveal);
}
